// ─── Qué acciones ve cada cargo en el detalle del período (H10) ─────────────
// Lo que el servidor rechaza no se muestra. Editar, cancelar, reactivar,
// borrar, matricular, dar de baja y cambiar de sección son de administración,
// registro y decanato (`useCanManageAcademics` = SECTION_MANAGEMENT_ROLES del
// servidor). Un docente o un mentor llega a esta pantalla para VER: ve la
// lista de inscritos y el acta de sus secciones, sin botones que fallarían.

export type SectionRowAction = 'edit' | 'reactivate' | 'hardDelete' | 'cancel' | 'enroll';

export function sectionRowActions(opts: {
  canManage: boolean;
  status: string;
}): SectionRowAction[] {
  if (!opts.canManage) return [];
  return opts.status === 'cancelled' ? ['reactivate', 'hardDelete'] : ['edit', 'cancel', 'enroll'];
}

export function rosterRowActions(opts: {
  canManage: boolean;
  /** La inscripción está vigente. */
  active: boolean;
  /** Hay otra sección del mismo curso a la que cambiarlo. */
  hasMoveTarget: boolean;
}): { drop: boolean; move: boolean } {
  const can = opts.canManage && opts.active;
  return { drop: can, move: can && opts.hasMoveTarget };
}
